import { createElement, Fragment } from "@wordpress/element";

/**
 * External dependencies
 */
import classnames from 'classnames';
/**
 * WordPress dependencies
 */

import { withSelect } from '@wordpress/data';
import { compose } from '@wordpress/compose';
import { __ } from '@wordpress/i18n';
import { InspectorControls, InnerBlocks, PanelColorSettings, withColors } from '@wordpress/block-editor';

function GroupEdit(_ref) {
  var className = _ref.className,
      setBackgroundColor = _ref.setBackgroundColor,
      backgroundColor = _ref.backgroundColor,
      hasInnerBlocks = _ref.hasInnerBlocks;
  var styles = {
    backgroundColor: backgroundColor.color
  };
  var classes = classnames(className, backgroundColor.class, {
    'has-background': !!backgroundColor.color
  });
  return createElement(Fragment, null, createElement(InspectorControls, null, createElement(PanelColorSettings, {
    title: __('Color Settings'),
    colorSettings: [{
      value: backgroundColor.color,
      onChange: setBackgroundColor,
      label: __('Background Color')
    }]
  })), createElement("div", {
    className: classes,
    style: styles
  }, createElement("div", {
    className: "wp-block-group__inner-container"
  }, createElement(InnerBlocks, {
    renderAppender: !hasInnerBlocks && InnerBlocks.ButtonBlockAppender
  }))));
}

export default compose([withColors('backgroundColor'), withSelect(function (select, _ref2) {
  var clientId = _ref2.clientId;

  var _select = select('core/block-editor'),
      getBlock = _select.getBlock;

  var block = getBlock(clientId);
  return {
    hasInnerBlocks: !!(block && block.innerBlocks.length)
  };
})])(GroupEdit);
//# sourceMappingURL=edit.js.map